<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-md-8 col-sm-6 col-12">
          <h5>Online Application Forms</h5>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="row">
          <!-- Session Select -->
          <div class="col-md-2 col-sm-3 col-12 mb-2">
            <a-spin :spinning="sessionSpinning">
              <a-select v-if="pagepermission.viewable"
                size="large"
                v-model="selectedSession"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleSessionChange"
                :filterOption="false"
                :defaultValue="currentSession ? currentSession.id : ''"
              >
                <template v-for="schoolSession in schoolSessions">
                  <a-select-option :value="schoolSession.id" :key="schoolSession.id">
                      {{schoolSession.name}}
                      <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <!-- Add new Admission Form -->
          <div class="col-md-10 col-sm-9 col-12 text-sm-right">
            <add-application-form @created="handleCreated" v-if="pagepermission.insertable" />
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <application-form-table :data="data" :loading="loading"  @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import { find } from 'lodash'
import { mapState } from 'vuex'

import ApplicationFormTable from '@/components/applicationform/Table/index'
import AddApplicationForm from '@/components/applicationform/Forms/Add/index'

export default {
  components: {
    ApplicationFormTable,
    AddApplicationForm,
  },
  beforeMount: function() {
    let rc = this.$roleutility.checkpermission('online-application', 22)
    rc.then(data => {
      console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
    })
  },
  mounted: function() {
    this.getSessions()
    this.getApplicationForms()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      schoolSessions: [],
      selectedSession: undefined,
      sessionSpinning: false,
      pagepermission: { insertable: false, viewable: false, deletable: false, editable: false },
    }
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
    ...mapState(['user']),
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  methods: {
    getSessions: function() {
      this.sessionSpinning = true
      this.$http.get('/api/session')
        .then(({ data }) => {
          this.schoolSessions = data.data
          this.selectedSession = find(data.data, ['is_current', 1]).id
          this.sessionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getApplicationForms() {
      this.loading = true
      this.$http.get('/api/online-application', {
        params: {
          session_id: this.selectedSession,
          limit: this.pageSize,
          page: this.current,
        },
      })
        .then(({ data }) => {
          this.data = data.data
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    handleCreated: function() {
      this.getApplicationForms()
    },
    handleUpdateTable: function() {
      this.getApplicationForms()
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }

      this.getApplicationForms()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getApplicationForms()
    },
    onChange(current) {
      this.current = current
      this.getApplicationForms()
    },
  },
}
</script>
<style>
  .error { padding: 25px; }
</style>
